function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_bf)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1343.19 719.706C1373.14 722.532 1399.52 700.128 1401.59 670.123L1428.68 277.287C1430.83 246.044 1405.81 219.639 1374.5 220.113L292.988 236.496C265.184 236.917 242.338 258.568 240.425 286.31L221.453 561.464C219.456 590.416 240.907 615.68 269.799 618.407L1343.19 719.706Z",
  stroke: "#E1079D",
  strokeWidth: 3
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_bf)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1343.19 719.706C1373.14 722.532 1399.52 700.128 1401.59 670.123L1428.68 277.287C1430.83 246.043 1405.81 219.639 1374.5 220.113L292.988 236.496C265.184 236.917 242.338 258.568 240.425 286.309L221.453 561.463C219.456 590.416 240.907 615.68 269.799 618.407L1343.19 719.706Z",
  stroke: "#E1079D",
  strokeWidth: 3
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_bd)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1343.19 719.706C1373.14 722.532 1399.52 700.128 1401.59 670.123L1428.68 277.287C1430.83 246.043 1405.81 219.639 1374.5 220.113L292.988 236.496C265.184 236.917 242.338 258.568 240.425 286.309L221.453 561.463C219.456 590.416 240.907 615.68 269.799 618.407L1343.19 719.706Z",
  stroke: "#E1079D",
  strokeWidth: 3
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter3_bd)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1321.67 680.324C1352.56 681.071 1378 656.236 1378 625.34L1378 231.301C1378 199.182 1350.59 173.897 1318.58 176.479L188.579 267.608C160.01 269.911 138 293.768 138 322.43L138 598.001C138 627.858 161.821 652.263 191.67 652.985L1321.67 680.324Z",
  fill: "#12FED9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1321.69 679.56C1352.15 680.297 1377.24 655.807 1377.24 625.34L1377.24 231.301C1377.24 199.628 1350.21 174.694 1318.64 177.24L188.64 268.369C160.468 270.641 138.764 294.166 138.764 322.43L138.764 598.001C138.764 627.444 162.254 651.509 191.688 652.221L1321.69 679.56Z",
  stroke: "white",
  strokeWidth: 1.52734
}));

var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_bf",
  x: 199.3,
  y: 125.808,
  width: 1249.66,
  height: 614.288,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImage",
  stdDeviation: 5.34569
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 7.5,
  result: "effect2_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_bf",
  x: 199.3,
  y: 125.808,
  width: 1249.66,
  height: 614.288,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImage",
  stdDeviation: 5.34569
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 7.5,
  result: "effect2_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_bd",
  x: 76.8396,
  y: 0.527466,
  width: 1586.22,
  height: 950.849,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImage",
  stdDeviation: 5.34569
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 45.8202,
  dy: 43
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 91.6404
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.105882 0 0 0 0 0.192157 0 0 0 0 0.258824 0 0 0 0.13 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_backgroundBlur",
  result: "effect2_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect2_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter3_bd",
  x: 0.539307,
  y: 36.0161,
  width: 1606.56,
  height: 870.605,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImage",
  stdDeviation: 5.34569
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 45.8202,
  dy: 43
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 91.6404
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.105882 0 0 0 0 0.192157 0 0 0 0 0.258824 0 0 0 0.13 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_backgroundBlur",
  result: "effect2_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect2_dropShadow",
  result: "shape"
})));

function SvgMintContentBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "138 176.3 1292.31 545.15",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMintContentBg);
export default __webpack_public_path__ + "static/media/mint-content-bg.71582eef.svg";
export { ForwardRef as ReactComponent };